"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinnerWrapper = exports.StyledSpinnerInnerContainer = exports.StyledSpinnerContainer = exports.StyledSpinner = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var animationRotate = (0, _styledComponents.keyframes)(["100%{transform:rotate(360deg);}"]);
var animationDash = (0, _styledComponents.keyframes)(["0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}"]);

var StyledSpinnerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Spinnerstyles__StyledSpinnerWrapper",
  componentId: "sc-ipidv9-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w-100"]))));

exports.StyledSpinnerWrapper = StyledSpinnerWrapper;

var StyledSpinnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "Spinnerstyles__StyledSpinnerContainer",
  componentId: "sc-ipidv9-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["aspect-ratio aspect-ratio--1x1"]))));

exports.StyledSpinnerContainer = StyledSpinnerContainer;

var StyledSpinnerInnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "Spinnerstyles__StyledSpinnerInnerContainer",
  componentId: "sc-ipidv9-2"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["relative aspect-ratio--object"]))));

exports.StyledSpinnerInnerContainer = StyledSpinnerInnerContainer;

var StyledSpinner = _styledComponents["default"].svg.withConfig({
  displayName: "Spinnerstyles__StyledSpinner",
  componentId: "sc-ipidv9-3"
})(["animation:", " 2s linear infinite;position:absolute;width:100%;height:100%;left:0;& > circle{stroke:var(--", ");stroke-linecap:round;animation:", " 1.5s ease-in-out infinite;}"], animationRotate, function (_ref) {
  var spinner = _ref.theme.spinner;
  return spinner.color;
}, animationDash);

exports.StyledSpinner = StyledSpinner;